<template>
    <a-form
        layout="horizontal"
    >   
        
        <a-form-item
            v-bind="formItemLayout"
        >
            <h3
                slot="label"
            >
                {{ label }}
            </h3>
            <a-input
                :value="text"
                v-on:change="textChange"
            >
                <a-icon slot="prefix" :type="icon"/>
            </a-input>
        </a-form-item>    
    </a-form>
</template>

<script>
export default {
    name: 'SearchInput',

    props: {
        text: String,
        label: String,
        icon: {
            type: String,
            default: 'ellipsis'
        }
    },
    model: {
        prop: 'text',
        event: 'textChange'
    },
    data() {
        return {
            formItemLayout: {
                labelCol: { span: 24 },
                wrapperCol: { span: 24 }
            },
        }
    },

    methods: {
        textChange(event) {
            this.$emit('textChange', event.target.value);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>